import * as React from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useGetPriorities } from "security-app/hooks/useInvestigationsAPI";
import { Spinner } from "components/common";
import FilterValueSelect from "views/components/widgets/overview-configuration/filters/FilterValueSelect";
const StatusFilter = ({ value, onChange, selectedPriorities }) => {
  const { t } = useTranslation("enterprise_security_investigations");
  const { priorities, loadingPriorities } = useGetPriorities();
  const priorityOptions = useMemo(
    () => priorities.map((priority) => ({
      value: String(priority.priority),
      label: priority.text,
      disabled: selectedPriorities.includes(priority.id)
    })).sort((a, b) => +a.value - +b.value),
    [priorities, selectedPriorities]
  );
  if (loadingPriorities) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(
    FilterValueSelect,
    {
      value,
      onChange,
      placeholder: t("widget_filters.select_priority"),
      options: priorityOptions
    }
  );
};
export default StatusFilter;
